import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import SingleTelletModal from '@/components/modals/SingleTelletModal';

export interface ITelletsTableProps {
  name: string;
  status: string;
  number_of_respondents: number;
  date_created: string;
  date_published: string;
  published_by: string;
}

export const SuperAdminTelletColumns = () => {
  const columns: ColumnDef<ITelletsTableProps>[] = [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <SingleTelletModal rowData={row.original} />,
    },
    {
      accessorKey: 'status',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Status
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <p
          className={cn(
            'whitespace-nowrap',
            row.getValue('status') === 'Completed' &&
              'px-4 text-green-800 w-fit py-px bg-green-200 rounded-full',
            row.getValue('status') === 'In Progress' &&
              'px-5 text-orange-800 w-fit py-px bg-orange-200 rounded-full',
          )}
        >
          {row.getValue('status')}
        </p>
      ),
    },
    {
      accessorKey: 'number_of_respondents',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Nr. Respondents
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('number_of_respondents')}</>,
    },
    {
      accessorKey: 'date_created',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Date Created
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('date_created')}</>,
    },
    {
      accessorKey: 'date_published',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Date Published
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('date_published')}</>,
    },
    {
      accessorKey: 'published_by',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Published By
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('published_by')}</>,
    },
  ];
  return columns;
};
